import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    state: { isFavouriteLoading },
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commDisplay, setCommDisplay] = useParameter<string[]>("@commodities_display");
  const [units, setUnits] = useParameter<number[]>("@units");

  useEffect(() => {
    setParameters(title, {
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_display": commDisplay,
      "@units": units,
    });
  }, [title, business, commodities, commDisplay, units, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setBusiness(parameters["@business-units"].map(Number)[0]);
      setCommodities(parameters["@commodities"].map(Number));
      setCommDisplay(parameters["@commodities_display"]);
      setUnits(parameters["@units"].map(Number));
    },
    [setBusiness, setCommodities, setCommDisplay, setUnits]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);

  return { isFavouriteLoading };
}
